import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import useTranslations from '../../../i18n/useTranslations'
import useIsMobile from '../../../hooks/useIsMobile'
import ModalLayout from '../layout'

const ConfirmationWithError = ({ onDiscard, onAmend }) => {
  const t = useTranslations()

  const isMobile = useIsMobile()

  return (
    <ModalLayout
      isOpen
      title={t('message:form-errors:title')}
      content={t('message:form-errors:detail')}
      onClose={onAmend}
      actions={
        <>
          <Button
            type="button"
            size={isMobile ? 'medium' : 'small'}
            variant="outlined"
            onClick={onDiscard}
          >
            {t('action:discard-changes')}
          </Button>
          <Button
            type="button"
            size={isMobile ? 'medium' : 'small'}
            onClick={onAmend}
          >
            {t('action:fix-errors')}
          </Button>
        </>
      }
    />
  )
}

ConfirmationWithError.propTypes = {
  onDiscard: PropTypes.func.isRequired,
  onAmend: PropTypes.func.isRequired,
}

export default ConfirmationWithError
